var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_4095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 10.75C13.135 10.75 14.0179 10.3944 14.669 9.76149C15.32 9.12855 15.6857 8.27011 15.6857 7.375C15.6857 6.47989 15.32 5.62145 14.669 4.98851C14.0179 4.35558 13.135 4 12.2143 4C11.2936 4 10.4106 4.35558 9.75961 4.98851C9.10859 5.62145 8.74286 6.47989 8.74286 7.375C8.74286 8.27011 9.10859 9.12855 9.75961 9.76149C10.4106 10.3944 11.2936 10.75 12.2143 10.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58571 17.5C7.58571 17.5 6.42857 17.5 6.42857 16.375C6.42857 15.25 7.58571 11.875 12.2143 11.875C16.8429 11.875 18 15.25 18 16.375C18 17.5 16.8429 17.5 16.8429 17.5H7.58571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03566 17.5C5.8642 17.1488 5.77865 16.7637 5.78571 16.375C5.78571 14.8506 6.57257 13.2812 8.02594 12.19C7.30062 11.9722 6.54477 11.866 5.78571 11.875C1.15714 11.875 0 15.25 0 16.375C0 17.5 1.15714 17.5 1.15714 17.5H6.03566Z",
    fill: "white",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20714 10.75C5.97438 10.75 6.71019 10.4537 7.2527 9.92624C7.79522 9.39879 8.1 8.68342 8.1 7.9375C8.1 7.19158 7.79522 6.47621 7.2527 5.94876C6.71019 5.42131 5.97438 5.125 5.20714 5.125C4.43991 5.125 3.7041 5.42131 3.16158 5.94876C2.61907 6.47621 2.31429 7.19158 2.31429 7.9375C2.31429 8.68342 2.61907 9.39879 3.16158 9.92624C3.7041 10.4537 4.43991 10.75 5.20714 10.75Z",
    fill: "white",
    fillOpacity: 0.34
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_4095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.f5031a87958eef3766f1635b7b52aeda.svg";
export { ForwardRef as ReactComponent };